import { render, staticRenderFns } from "./EditDecisionApproved.vue?vue&type=template&id=2d0a1a60&scoped=true"
import script from "./EditDecisionApproved.vue?vue&type=script&lang=js"
export * from "./EditDecisionApproved.vue?vue&type=script&lang=js"
import style0 from "./EditDecisionApproved.vue?vue&type=style&index=0&id=2d0a1a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a1a60",
  null
  
)

export default component.exports